<template>
  <div class="create-comment-skeleton">
    <div class="create-comment-skeleton__container">
      <div class="skeleton-loader textarea" />
      <div class="skeleton-loader text" />
      <div class="skeleton-loader text" />
      <div class="skeleton-loader" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateCommentSkeleton',
};
</script>
